let apiKey  = 'AIzaSyBglMemahr7V71bDMNzhSyceFzrRI4K5xo'

export default apiKey